module.exports = __webpack_public_path__ + "static/media/Digital_Championship.b4ede42e.png";